import timeoffTableHTML from './timeoffTableComponent.html';

export default {
  bindings: {
    data: '<',
    columns: '<',
    selectedLeaveTypeIds: '<',
    sortMethod: '=?orderBy',
    showDurationsAsDecimals: '<',
    filtersOpened: '<',
    statsOpened: '<',
    getDataForExport: '=?',
  },
  controllerAs: 'ctrl',
  controllerProvider: async () =>
    (await import(/* webpackChunkName: "reports" */ './timeoffTableComponentCtrl')).default,
  templateUrl: timeoffTableHTML,
};
